import { Component } from 'react';
import { captureException } from '@sentry/browser';

export class SentryErrorHandler extends Component {
    state = { error: null };

    componentDidCatch(error, errorInfo) {
        this.setState({ error });
        captureException(error, { extra: errorInfo });
    }

    render() {
        if (this.state.error) {
            //render fallback UI
            return this.props.fallback || null;
        } else {
            //when there's not an error, render children untouched
            return this.props.children;
        }
    }
}
